import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { SnPlayerCommonModule } from '@lib/player/common';
import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';

import { SnImagePlayerComponent } from './image-player.component';
@NgModule({
  imports: [
    // Angular
    CommonModule,
    // Material
    MatProgressSpinnerModule,
    // Libs
    SnPlayerCommonModule,
    SnButtonModule,
    SnIconModule,
    MatMenuModule,
  ],
  exports: [SnPlayerCommonModule, SnImagePlayerComponent],
  declarations: [SnImagePlayerComponent],
})
export class SnImagePlayerModule {}
